import api from './api';

export const carrierService = {
  getCarriers: async (params = {}) => {
    try {
      const response = await api.get('/carriers', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching carriers:', error);
      throw error;
    }
  },
  
  getCarrierById: async (id) => {
    try {
      const response = await api.get(`/carriers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching carrier:', error);
      throw error;
    }
  },
  
  createCarrier: async (carrierData) => {
    try {
      const response = await api.post('/carriers', carrierData);
      return response.data;
    } catch (error) {
      console.error('Error creating carrier:', error);
      throw error;
    }
  },

  updateCarrier: async (id, carrierData) => {
    try {
      const response = await api.put(`/carriers/${id}`, carrierData);
      return response.data;
    } catch (error) {
      console.error('Error updating carrier:', error);
      throw error;
    }
  },

  deleteCarrier: async (id) => {
    try {
      const response = await api.delete(`/carriers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting carrier:', error);
      throw error;
    }
  },
  
  toggleCarrierStatus: async (id, isActive) => {
    try {
      const response = await api.patch(`/carriers/${id}/status`, { isActive });
      return response.data;
    } catch (error) {
      console.error('Error toggling carrier status:', error);
      throw error;
    }
  },

  getCarrierVehicles: async (id, params = {}) => {
    try {
      const response = await api.get(`/carriers/${id}/vehicles`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching carrier vehicles:', error);
      throw error;
    }
  },

  getCarrierAccount: async (id) => {
    try {
      const response = await api.get(`/carriers/${id}/account`);
      return response.data;
    } catch (error) {
      console.error('Error fetching carrier account:', error);
      throw error;
    }
  },

  getCarriersWithVehicles: async () => {
    try {
      const response = await api.get('/carriers/with-vehicles');
      return response.data;
    } catch (error) {
      console.error('Error fetching carriers with vehicles:', error);
      throw error;
    }
  },

  // Finans sayfası için taşıyıcı firmaları
  getCarriersForFinance: async () => {
    try {
      const response = await api.get('/carriers/finance');
      return response.data;
    } catch (error) {
      console.error('Error fetching carriers for finance:', error);
      throw error;
    }
  },

  // Taşıyıcı firma finans detayları
  getCarrierFinanceDetails: async (carrierId) => {
    try {
      const response = await api.get(`/carriers/${carrierId}/finance-details`);
      return response.data;
    } catch (error) {
      console.error('Error fetching carrier finance details:', error);
      throw error;
    }
  }
};

export default carrierService;
